export class FunnelBackModule {

    constructor() {
        this.domain = $("#funnelbackDomain").val();
        const col = $("#funnelbackCollection").val();
        this.profile = "/s/search.json?profile=spire-website";
        this.suggestProfile = "/s/suggest.json?profile=spire-website"; 
        this.collection = "collection=" + col;
        this.searchPathUrl = "/search";

        this.maxdist = this.urlParam('maxdist'); // miles
        this.cord = this.urlParam('origin');
        this.query = this.urlParam('query');
        let profile = this.urlParam('profile');

        // Filter
        this.all = false;
        this.consultants = false;
        this.treatments = false;
        this.other = false;

        let hospitalProfile = profile.replace("spire-", "").replace("spire+", "").replaceAll("-", " ");

        this.hospital = this.convertStringToUpperCaseEachWord(hospitalProfile);

        this.showList = (this.cord.length > 0 || this.hospital.length > 0);

        if ($("#funnelback").length > 0) {
            this.init();
        }

    }

    

    init() {

        const that = this;


        that.setClickEvents();
    }

    autocomplete(inp) {

        var that = this;

        var currentFocus;

        inp.addEventListener("input", function (e) {
            var a, b, i, val = this.value;

            var outerThat = that;

            $(".spire-autocomplete").hide();

            if (!val) { return false; }
            currentFocus = -1;

            let query = $(this).val();
            that.requestAutocompleteResults(query, function (data) {
                $(".spire-autocomplete").show();

                if (data.length == 0) {
                    $(".spire-autocomplete").hide();
                    return;
                }

                if (data.length > 0) {
                    $(".spire-autocomplete ul").html("");
                    $(".spire-autocomplete").show();

                    for (i = 0; i < data.length; i++) {
                        $(".spire-autocomplete ul").append(`<li><a><span>${data[i].disp}</span></a></li>`)
                    }

                }
            });

        });

        inp.addEventListener("keydown", function (e) {

            let x = $(".spire-autocomplete ul li");

            if (e.keyCode == 40) {
                currentFocus++;
                addActive(x);
            }
            else if (e.keyCode == 38) {
                currentFocus--;
                addActive(x);
            } else if (e.keyCode == 13) {
                e.preventDefault();

                if (currentFocus > -1) {
                    if (x) {
                        const obj = $(x[currentFocus]);
                        const aobj = obj.find("a");
                        const path = aobj.attr("href");
                        window.location.href = path;
                    }
                }
                else {
                    const path = that.searchPathUrl + "/?query=" + $(this).val().replaceAll(" ", "+");
                    window.location.href = path;
                }
            }

        });

        // close autocomplete if mouse clicked outside.
        $(document).on("click", "body", function (e) {
            if ($(e.target).parents(".spire-autocomplete").length === 0) {
                that.currentFocus = -1;
                $(".spire-autocomplete ul li").remove();
                $(".spire-autocomplete").hide();
            }
        });

        function addActive(x) {
            if (!x) return false;
            removeActive(x);
            if (currentFocus >= x.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = (x.length - 1);

            if (x[currentFocus] != undefined) {
                x[currentFocus].classList.add("autocomplete-active");
            }
            
        }

        function removeActive(x) {
            /*a function to remove the "active" class from all autocomplete items:*/
            for (var i = 0; i < x.length; i++) {
                x[i].classList.remove("autocomplete-active");
            }
        }

    }


    requestAutocompleteResults(query, success) {
        let url = this.domain + this.suggestProfile + "&" + this.collection + "&fmt=json++&alpha=0.5&show=10&sort=0&partial_query=" + query;
        $.ajax({
            type: "GET",
            url: url,
            success: success
        });
    }

    /* Click Events */
    setClickEvents() {

        let that = this;

        this.autocomplete(document.getElementById("query-finder"));
        
        $("#funnelback").on("click", "#clear-search", function (e) {
            e.preventDefault();

            $("#query-finder").val("");

        });

        $(".spire-autocomplete ul").on("click", function (e) {
            e.preventDefault();
            let query = e.target.textContent;
            $("#query-finder").val(query);
            $("#siteSearchSubmit").click();
        })
        
        $("#hospital").on("change", function (e) {
            submitForm();
        });
        
        $("input[name=region]").on("change", function (e) {
            submitForm();
        });
        
        $("input[name=searchFilter]").on("change", function (e) {
            submitForm();
        })
        
        let submitForm = function() {
            $("#globalSpinner").show();
            $("#siteSearchSubmit").click();
        }
    }
    /* End Click Events */




    /* Utilities */

    convertStringToUpperCaseEachWord(str) {

        if (str.length > 0) {
            const words = str.split(" ");
            for (let i = 0; i < words.length; i++) {
                words[i] = words[i][0].toUpperCase() + words[i].substr(1);
            }
            return words.join(" ");
        }
        return "";
    }

    urlParam(name) {
        let results = new RegExp('[\?&]' + name + '=([^&#]*)')
            .exec(decodeURIComponent(window.location.search));

        return (results !== null) ? results[1] || "" : "";
    }

    /* Utilities */
}